/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */

'use strict';
angular
  .module('http.account', [])
  /**
   * Service used to access all calls to the api rest service.
   */
  .factory('httpAccount', function ($http) {
    /**
     * Get the backup user for the organization.
     *
     * @returns {promise} A promise that when resolved will include an object.
     * {backupUser: userEmail}
     */
    var getBackupUser = function () {
      return $http({
        method: 'GET',
        url: 'api/account/backup/user'
      }).then(function (res) {
        return res.data;
      });
    };
    /**
     * Get the organization account data.
     *
     * @returns {promise} A promise that when resolved will include an object.
     * {created: createdDate}
     */
    var getOrg = function () {
      return $http({
        method: 'GET',
        url: 'api/account/org'
      }).then(function (res) {
        return res.data;
      });
    };
    /**
     * Returns the user info from the SF signed request of the currently logged-in user.
     *
     * @returns {promise} A promise that resolves to the user info of the currently logged-in user.
     */
    var getCurrentUser = function () {
      return $http({
        method: 'GET',
        url: 'api/account'
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Get the maintenance notification message if one exists.
     *
     * @returns {promise} A promise that when resolved will include an object.
     * {message: message || false}
     */
    var getMaintenanceNotification = function () {
      return $http({
        method: 'GET',
        url: 'api/account/notification'
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Make the current user the backup (API) user. The backend authenticates the user against Salesforce through the
     * JWT bearer flow; no browser round-trip is required.
     *
     * @returns {promise} A promise that resolves on success and rejects (with the error response) otherwise.
     */
    var updateBackupUser = function () {
      return $http({
        method: 'POST',
        url: 'api/account/backup/user'
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Update adminOnly setting for org.
     * @returns {Promise} A promise that will resolve after update is complete.
     */
    var updateAdminOnly = function (adminOnly) {
      return $http({
        method: 'POST',
        url: 'api/account/admin-only',
        data: {
          adminOnly: adminOnly
        }
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Get the account status.
     *
     * @returns {Promise} - A promise that resolves into an object containing account type and expiration.
     */
    var getAccountStatus = function () {
      return $http({
        method: 'GET',
        url: 'api/account/status'
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Update backup start time setting for org.
     *
     * @param {Number|Null} backupStartTime - The backup start time.
     * @returns {Promise} A promise that will resolve after update is complete.
     */
    var updateBackupStartTime = function (backupStartTime) {
      return $http({
        method: 'POST',
        url: 'api/custom-backup-time/set',
        data: {
          backupStartTime: backupStartTime
        }
      }).then(function (res) {
        return res.data;
      });
    };

    const logout = function () {
      return $http({
        method: 'GET',
        url: 'api/logout'
      });
    };

    const updateITCFeature = function (itComplete) {
      return $http({
        method: 'POST',
        url: 'api/account/it-complete',
        data: {
          itComplete: itComplete
        }
      }).then((response) => {
        return response.data;
      });
    };

    const getRedirectUrlToBindOrganization = function () {
      return $http({
        method: 'POST',
        url: 'api/it-complete/organization'
      }).then((response) => {
        return response.data;
      });
    };

    const getRedirectUrlToUnBindOrganization = function () {
      return $http({
        method: 'DELETE',
        url: 'api/it-complete/organization'
      }).then((response) => {
        return response.data;
      });
    };

    return {
      getAccountStatus: getAccountStatus,
      getBackupUser: getBackupUser,
      getCurrentUser: getCurrentUser,
      getMaintenanceNotification: getMaintenanceNotification,
      getOrg: getOrg,
      getRedirectUrlToBindOrganization: getRedirectUrlToBindOrganization,
      getRedirectUrlToUnBindOrganization: getRedirectUrlToUnBindOrganization,
      logout: logout,
      updateAdminOnly: updateAdminOnly,
      updateBackupStartTime: updateBackupStartTime,
      updateBackupUser: updateBackupUser,
      updateITCFeature: updateITCFeature
    };
  });
